import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { filterAttributes } from 'utils';

import css from './FluidImage.module.scss';

const FluidImage = ({
    altText,
    className,
    image,
    visible,
    ...props,
}) => (
    <div
        className={cn(css.image, className, {
            [css.visible]: visible,
        })}
        style={{
            backgroundImage: visible && image &&  `url('${image}')`
        }}
        {...filterAttributes(props, /^data-/)}
    >
        {visible && <img src={image} alt={altText ? altText : ''}/>}
    </div>
);

FluidImage.propTypes = {
    altText: PropTypes.string,
    className: PropTypes.string,
    image: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
};

FluidImage.defaultProps = {
    visible: true,
};

export default FluidImage;



// WEBPACK FOOTER //
// ./src/components/FluidImage/FluidImage.jsx